export default __webpack_public_path__ + "static/media/product-ctg-bg.96c03d4a.webp";